import { render, staticRenderFns } from "./RoleOwner.vue?vue&type=template&id=22dc4634&scoped=true&"
import script from "./RoleOwner.vue?vue&type=script&lang=js&"
export * from "./RoleOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dc4634",
  null
  
)

export default component.exports